// export const DEPLOY_HOST_URL = "https://compass.haish.site"
export const DEPLOY_HOST_URL = "https://compasssite.up.railway.app";
// export const DEPLOY_HOST_URL = "http://localhost:3000"
